var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.579,
    height: 15.221,
    viewBox: "0 0 46.579 15.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_783",
    "data-name": "Group 783",
    transform: "translate(7917.949 12947.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_782",
    "data-name": "Group 782",
    transform: "translate(-7917.949 -12947.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_330",
    "data-name": "Rectangle 330",
    transform: "translate(38.9) rotate(90)",
    fill: "#40AEEE",
    stroke: "#40AEEE",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.221,
    height: 38.9,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14.221,
    height: 37.9,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_331",
    "data-name": "Rectangle 331",
    transform: "translate(46.579) rotate(90)",
    fill: "#40AEEE",
    stroke: "#40AEEE",
    strokeWidth: 1,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.221,
    height: 18.063,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14.221,
    height: 17.063,
    rx: 2.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "_90_10",
    "data-name": "90/10",
    transform: "translate(-7912 -12937)",
    fill: "#0c3150",
    fontSize: 9,
    fontFamily: "Graphie-Bold, Graphie",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "90/10")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfit);
export default __webpack_public_path__ + "static/media/profit.1a40345a9afb9910b20d19f2bec5f6b5.svg";
export { ForwardRef as ReactComponent };